// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `button {
  background-color: #0e0635;
  font-family: IBM Plex Mono;
  font-weight: 700;
  text-transform: uppercase;
  padding: 12px 18px;
  border-radius: 4px;
  border: solid 2px #121212;
  box-shadow: 4px 4px #121212;
  transition: transform 50ms,
  box-shadow 50ms;
}

button:hover {
  transform: translate(2px, 2px);
  box-shadow: 2px 2px #121212;
}

.main-content {
  padding: 20px;
  font-family: IBM Plex Mono;
  max-width: 1200px;
  margin: 0 auto;
}

.header-info {
  margin-bottom: 30px;
}

.content-wrapper {
  display: flex;
  gap: 20px;
}

.left-container {
  flex: 0.4 1;
  padding: 20px;
  border: 1px solid #ddd;
  border-radius: 4px;
  position: relative;
  min-height: 200px;
}

.right-container {
  flex: 0.6 1;
  padding: 20px;
  border: 1px solid #ddd;
  border-radius: 4px;
  position: relative;
  min-height: 200px;
}

.restaurant-item {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.fop-item {
  margin-bottom: 15px;
  padding: 10px;
  border: 1px solid #eee;
  border-radius: 4px;
}

.form-container {
  padding: 20px;
  border: 1px solid #ddd;
  border-radius: 4px;
  background: white;
  text-align: center;
}

.button-group {
  display: flex;
  gap: 10px;
  margin-top: 20px;
  justify-content: center;
}

.package-options {
  margin: 20px 0;
}

.status-message {
  margin-top: 10px;
  color: #666;
}

.error-message {
  color: #f44336;
}

.success-message {
  color: #4caf50;
}

@media (max-width: 768px) {
  .content-wrapper {
    flex-direction: column;
  }
  
  .button-group {
    position: static;
    margin-top: 20px;
  }
}

.container-about-info-prof {
  border: solid 2px #121212;
  transition: transform 50ms;
  width: 90%;
  max-width: 1200px;
  min-width: 320px;
  font-family: IBM Plex Mono;
  padding: 20px;
  background: rgb(255, 255, 255);
}

.download-button {
  background-color: #ffffff;
  color: rgb(0, 0, 0);

  border: 2px solid #000000;
  border-radius: 4px;
  cursor: pointer;
  margin-bottom: 15px;
  transition: background-color 0.3s ease;
}

.download-button:hover {
  background-color: #e6f3ff;
}

.details-button {
  background-color: #ffa500;
}


.download-button-ch {
  background-color: #083806;
  color: rgb(255, 255, 255);
  padding: 8px 15px;
  border: 2px solid #000000;
  border-radius: 4px;
  cursor: pointer;
  margin-bottom: 15px;
  transition: background-color 0.3s ease;
}

.download-button-ch:hover {
  background-color: #1e8b30;
  color: rgb(255, 255, 255);
}

.details-button-ch {
  background-color: #ffa500;
}`, "",{"version":3,"sources":["webpack://./src/components/fopForm/Fop.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,2BAA2B;EAC3B;iBACe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,WAAS;EACT,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,WAAS;EACT,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;AACF;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,UAAU;EACV,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;;EAEnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;;AAGA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":["button {\r\n  background-color: #0e0635;\r\n  font-family: IBM Plex Mono;\r\n  font-weight: 700;\r\n  text-transform: uppercase;\r\n  padding: 12px 18px;\r\n  border-radius: 4px;\r\n  border: solid 2px #121212;\r\n  box-shadow: 4px 4px #121212;\r\n  transition: transform 50ms,\r\n  box-shadow 50ms;\r\n}\r\n\r\nbutton:hover {\r\n  transform: translate(2px, 2px);\r\n  box-shadow: 2px 2px #121212;\r\n}\r\n\r\n.main-content {\r\n  padding: 20px;\r\n  font-family: IBM Plex Mono;\r\n  max-width: 1200px;\r\n  margin: 0 auto;\r\n}\r\n\r\n.header-info {\r\n  margin-bottom: 30px;\r\n}\r\n\r\n.content-wrapper {\r\n  display: flex;\r\n  gap: 20px;\r\n}\r\n\r\n.left-container {\r\n  flex: 0.4;\r\n  padding: 20px;\r\n  border: 1px solid #ddd;\r\n  border-radius: 4px;\r\n  position: relative;\r\n  min-height: 200px;\r\n}\r\n\r\n.right-container {\r\n  flex: 0.6;\r\n  padding: 20px;\r\n  border: 1px solid #ddd;\r\n  border-radius: 4px;\r\n  position: relative;\r\n  min-height: 200px;\r\n}\r\n\r\n.restaurant-item {\r\n  display: flex;\r\n  align-items: center;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.fop-item {\r\n  margin-bottom: 15px;\r\n  padding: 10px;\r\n  border: 1px solid #eee;\r\n  border-radius: 4px;\r\n}\r\n\r\n.form-container {\r\n  padding: 20px;\r\n  border: 1px solid #ddd;\r\n  border-radius: 4px;\r\n  background: white;\r\n  text-align: center;\r\n}\r\n\r\n.button-group {\r\n  display: flex;\r\n  gap: 10px;\r\n  margin-top: 20px;\r\n  justify-content: center;\r\n}\r\n\r\n.package-options {\r\n  margin: 20px 0;\r\n}\r\n\r\n.status-message {\r\n  margin-top: 10px;\r\n  color: #666;\r\n}\r\n\r\n.error-message {\r\n  color: #f44336;\r\n}\r\n\r\n.success-message {\r\n  color: #4caf50;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .content-wrapper {\r\n    flex-direction: column;\r\n  }\r\n  \r\n  .button-group {\r\n    position: static;\r\n    margin-top: 20px;\r\n  }\r\n}\r\n\r\n.container-about-info-prof {\r\n  border: solid 2px #121212;\r\n  transition: transform 50ms;\r\n  width: 90%;\r\n  max-width: 1200px;\r\n  min-width: 320px;\r\n  font-family: IBM Plex Mono;\r\n  padding: 20px;\r\n  background: rgb(255, 255, 255);\r\n}\r\n\r\n.download-button {\r\n  background-color: #ffffff;\r\n  color: rgb(0, 0, 0);\r\n\r\n  border: 2px solid #000000;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n  margin-bottom: 15px;\r\n  transition: background-color 0.3s ease;\r\n}\r\n\r\n.download-button:hover {\r\n  background-color: #e6f3ff;\r\n}\r\n\r\n.details-button {\r\n  background-color: #ffa500;\r\n}\r\n\r\n\r\n.download-button-ch {\r\n  background-color: #083806;\r\n  color: rgb(255, 255, 255);\r\n  padding: 8px 15px;\r\n  border: 2px solid #000000;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n  margin-bottom: 15px;\r\n  transition: background-color 0.3s ease;\r\n}\r\n\r\n.download-button-ch:hover {\r\n  background-color: #1e8b30;\r\n  color: rgb(255, 255, 255);\r\n}\r\n\r\n.details-button-ch {\r\n  background-color: #ffa500;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
